export default function sortByDates(items) {
  items.sort((a, b) => a.date - b.date);
}
